export default {
    data() {
      return {
        fieldsTabela: [],
        tbFieldsAgenda: [],
        tbCommonFields: [
          {
            key: "selecao",
            sortable: false,
            label: "Sel.",
            thClass: "celula-selecao",
            tdClass: "celula-selecao",
          },
          {
            key: "cnj",
            sortable: false,
            label: "CNJ",
            visible: false,
            thClass: "celula-cnj",
            tdClass: "celula-cnj",
          },
        ],
        tbFieldsPrazo: [
          {
            key: "tipoPrazo",
            sortable: false,
            label: "Tipo",
            tdClass: "text-center",
            thClass: "header-prazo",
            thStyle: {
              background: "#CFE2F3 !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
            },
          },
          {
            key: "statusPrazo",
            sortable: false,
            label: "Status Prazo",
            tdClass: (value) => {
              return value === "CUMPRIDO" ? "text-center cell-warning" : "text-center"
            },
            thClass: "header-prazo",
            thStyle: {
              background: "#CFE2F3 !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
              width: "10px",
            },
          },
          {
            key: "dataHoraDisponibilizacao",
            sortable: false,
            label: "Data Envio",
            thClass: "header-prazo",
            tdClass: "text-center",
            thStyle: {
              background: "#CFE2F3 !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
            },
          },
          {
            key: "dias",
            sortable: false,
            label: "Dias Prazo",
            thClass: "header-prazo",
            tdClass: "text-center",
            thStyle: {
              background: "#CFE2F3 !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
              width: "5px",
            },
          },
          {
            key: "dataLeitura",
            sortable: false,
            label: "Data Leitura",
            thClass: "header-prazo",
            tdClass: "text-center",
            thStyle: {
              background: "#CFE2F3 !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
            },
          },
  
          {
            key: "dataVenc",
            sortable: false,
            label: "Data Venc.",
            thClass: "header-prazo",
            tdClass: (value) => {
              return new Date(value).toDateString() == new Date().toDateString() ? "text-center cell-danger" : "text-center"
            },
            thStyle: {
              background: "#CFE2F3 !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
            },
          },
  
          {
            key: "meuVenc",
            sortable: false,
            label: "Meu Venc.",
            thClass: "header-prazo",
            tdClass: (value) => {
              return new Date(value).toDateString() == new Date().toDateString() ? "text-center cell-danger" : "text-center"
            },
            thStyle: {
              background: "#CFE2F3 !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
            },
          },
          {
            key: "teorComunicacao",
            sortable: false,
            label: "Teor da Comunicação",
            thClass: "header-prazo",
            tdClass: "text-left",
            thStyle: {
              background: "#CFE2F3 !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
            },
          },
        ],
        tbFieldsProcesso: [
          {
            key: "classeProcessual",
            sortable: false,
            label: "Classe Processual",
            tdClass: "text-center",
            thClass: "header-processo",
            thStyle: {
              background: "#F4CCCC !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
            },
          },
          {
            key: "dataAju",
            sortable: false,
            label: "Data Aju.",
            tdClass: "text-center tdDataAju",
            thClass: "header-processo",
            thStyle: {
              background: "#F4CCCC !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
            },
          },
          {
            key: "status",
            sortable: false,
            label: "Status Grau",
            tdClass: "text-center",
            thClass: "header-processo",
            thStyle: {
              background: "#F4CCCC !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
            },
          },
          {
            key: "devedor",
            sortable: false,
            label: "Devedor",
            tdClass: "text-left",
            thClass: "header-processo",
            thStyle: {
              background: "#F4CCCC !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
            },
          },
        ],
        tbFieldsMinuta: [
          {
            key: "minuta",
            sortable: false,
            label: "Minuta",
            tdClass: "text-center",
            thClass: "header-minuta",
            thStyle: {
              background: "#D8EAD2 !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
            },
          },
          {
            key: "modeloUtilizado",
            sortable: false,
            label: "Modelo Utilizado",
            thClass: "header-minuta",
            thStyle: {
              background: "#D8EAD2 !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
            },
          },
          {
            key: "relacaoCdas",
            sortable: false,
            label: "Rel. CDAs",
            tdClass: "text-center",
            thClass: "header-minuta",
            thStyle: {
              background: "#D8EAD2 !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
            },
          },
          {
            key: "anexos",
            sortable: false,
            label: "Anexos",
            tdClass: "text-center",
            thClass: "header-minuta",
            thStyle: {
              background: "#D8EAD2 !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
            },
          },
          {
            key: "statusMinuta",
            sortable: false,
            label: "Status da Minuta",
            tdClass: "text-left",
            thClass: "header-minuta",
            thStyle: {
              background: "#D8EAD2 !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
            },
          },
          {
            key: "idAviso",
            sortable: false,
            label: "ID Aviso",
            tdClass: "text-left",
            thClass: "header-minuta",
            thStyle: {
              background: "#D8EAD2 !important",
              color: "#154051",
              fontWheight: "normal",
              fontSize: "0.95rem",
            },
          },
        ],
        fieldscda: [
          {
            key: "cnj",
            sortable: true,
            label: "CNJ",
          },
          {
            key: "numeroCda",
            sortable: true,
            label: "CDA",
          },
          {
            key: "tipoCredito",
            sortable: true,
            label: "Tipo",
          },
          {
            key: "valor",
            sortable: true,
            label: "Valor (R$)",
          },
          {
            key: "situacaoDae",
            sortable: true,
            label: "Status",
          },
        ],
        tbFieldsVencimentos: [
          {
            key: "dataVencimento",
            label: "Data de Venc.",
          },
          {
            key: "quantidade",
            label: "Quantidade",
          },
        ],
        colors: [
          "C6E2FF", "6495ED", "87CEEB", "ADD8E6", 
          "B0C4DE", "7FFFD4", "90EE90", "DAA520", 
          "B8860B", "BC8F8F","FFDEAD","F5DEB3",
          "DEB887","D2B48C","FF00FF","EE82EE",
          "DA70D6","DDA0DD","FFC0CB", "FFD700", 
          "ADD8E6", "E6E6FA", "FFE4E1", "F0E68C", 
          "D8BFD8", "B0E0E6", "AFEEEE", "F5F5DC", 
          "FFFACD", "E0FFFF", "F0FFF0", "E1F7D5", 
          "FFBDBD", "C9C9FF", "F1CBFF", "D3D3D3", 
          "D1F7C4", "FDE4CF", "FFF9C4", "FFECB3", 
          "E1F5FE", "F8BBD0", "DCEDC8", "FFCDD2"
        ],
        cnjColorsAvailable: [],
        cnjColorsMap: new Map(),
        cnpjColorsAvailable: [],
        cnpjColorsMap: new Map(),
      };
    }
  };